"use client";
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import FaqsStylistCard from "../../src/components/StylistDescriptionCard/FaqsStylistCard.js";
import { listCoupon } from "../../src/actions/couponActions.js";
import { useDispatch, useSelector } from "react-redux";
import SliderBannerShowData from "../../src/components/slider/sliderBanner.js";
import { listFaqs } from "../../src/actions/faqsAction.js";
import Link from "next/link";
import ChatPopup from "../../src/components/home/ChatPopup.js";



const Item = styled(
  Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));



// Reusable FAQ Button Component with Responsive Design
const FAQButton = ({ question, answer, isOpen, onClick }) => {
  return (
    <div className="mt-2">
      <button
        className={`flex justify-between w-full px-4 py-3 text-left focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75
          text-gray-600 bg-gray-50 hover:bg-emerald-50 rounded-lg 
          text-base md:text-lg lg:text-base`}  // Increase text size on mobile and tablet
        type="button"
        onClick={onClick}  // Trigger toggle when clicked
      >
        <span>{question}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
          className={`w-5 h-5 text-gray-500 transition-transform transform ${isOpen ? 'rotate-180' : ''}`}
        >
          <path
            fillRule="evenodd"
            d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      {/* Conditionally render the answer if the question is open */}
      {isOpen && (
        <div className="mt-2 px-4 py-2 text-gray-700 bg-gray-100 rounded-lg">
          {answer}
        </div>
      )}
    </div>
  );
};

function TermsConditions() {

  const classes = useStyles();


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const dispatch = useDispatch();
  const couponList = useSelector((state) => state.couponList);
  const { error, loading, coupons } = couponList;

  // const privacyPolicyList = useSelector((state)=>state.privacyPolicyList);
  // const {error1,loading1,privacyPolicy} =privacyPolicyList;

  // useEffect(()=>{
  //   dispatch(listCoupon());
  //   dispatch(listPrivacyPolicy());
  // },[dispatch])

  const FaqsQAList = useSelector((state) => state.FaqsQAList);
  const { error1, loading1, faqsQA } = FaqsQAList;


  useEffect(() => {
    dispatch(listCoupon());
    dispatch(listFaqs());
  }, [dispatch])



  const [showScrollButton, setShowScrollButton] = useState(false);

  // Effect for scrolling behavior
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Function to scroll to the top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };






  const [openIndex, setOpenIndex] = useState(null); // Track which FAQ is open (null means none are open)

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };


  const twoCupon = coupons.result ? coupons.result.slice(0, 2) : []






  
  return (
    <>
      <ChatPopup />
        <div className="bg-gray-50">
        <div className="flex justify-center py-10 lg:py-20 bg-indigo-100 w-full bg-cover bg-no-repeat bg-bottom" 
            style={{ backgroundImage: `url('/assets/Blog/BlogHeader.jpg')` }}>
            <div className="flex mx-auto w-full max-w-screen-2xl px-3 sm:px-10">
                <div className="w-full flex justify-center flex-col relative">
                    <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold font-serif text-center text-pink-600">Terms & Guidelines</h2>
                </div>
            </div>
        </div>
      
      <div className="bg-white">
        <div className="max-w-screen-2xl mx-auto lg:py-20 py-10 px-5 sm:px-10">
          

          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            These Terms of Service (the “Terms of Service” or “Agreement”) govern the use of the mobile and internet-based services and business tools offered by Door to Door Beauty (the “Company,” “Door to Door Beauty,” “We,” or “Us”) through the website  
            
            <Link
                className="inline-block w-auto text-pink-600 hover:text-pink-800 no-underline"
                href='/'
                target="_self"
                style={{color: "#DB2777;"}}
            >
                {"   "} &ensp;doortodoorbeauty.com &ensp;{"   "} 
            </Link>
            (the “Website”) and our mobile applications (collectively, the “Services”).      
          </p>
          <h5 style={{ fontSize: "1.4rem", color: "#000000", fontFamily: "'Roboto', sans-serif", marginTop: "40px", fontWeight: "bold", }} >PLEASE READ THESE TERMS OF SERVICE CAREFULLY.</h5>
            <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
              This is a legal agreement between Door to Door Beauty and you, which governs your use of the Services. Your use of the Services constitutes your acceptance of, and agreement to, all the terms and conditions in these Terms of Service and confirms that you are 18 years of age or older.
            </p>

          <h5 style={{ fontSize: "1.4rem", color: "#000000", fontFamily: "'Roboto', sans-serif", marginTop: "40px", fontWeight: "bold", }} >1. About Door to Door Beauty Services</h5>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            Door to Door Beauty connects certified beauty professionals with customers seeking convenient, at-home hair and beauty services.
          </p>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
             We do not guarantee or endorse the quality of services provided by professionals or the credentials, licensing, or registration of any individual offering services through our platform.
          </p>
          <h5 style={{ fontSize: "1.4rem", color: "#000000", fontFamily: "'Roboto', sans-serif", marginTop: "40px", fontWeight: "bold", }} >2. Door to Door Beauty Account</h5>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            Creating an account with Door to Door Beauty (“Account”) grants you a license to use our services, subject to these Terms of Service.
          </p>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            By registering, you consent to receive calls, SMS, or emails regarding promotions, updates, or service notifications.
          </p>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            You must provide accurate, up-to-date, and complete information during registration and promptly update any changes.
          </p>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            For convenience, our system may access your Google account or phone state to autofill login and signup information. This is strictly for account authentication.
          </p>
          <h5 style={{ fontSize: "1.4rem", color: "#000000", fontFamily: "'Roboto', sans-serif", marginTop: "40px", fontWeight: "bold", }} >3. Service Usage, Limitations & Modifications</h5>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            Door to Door Beauty reserves the right to modify, suspend, or discontinue services at any time without prior notice.
          </p>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            Direct client contact is prohibited: Do not share your personal phone number with customers. All bookings must be processed through the app or customer support. Unauthorized contact may result in a penalty of ₹50,000.
          </p>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            Report any additional services via the Door to Door Beauty Feedback Form immediately after the appointment.
          </p>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            <b>Scheduling:</b> Provide your availability in advance. Bookings are accepted 7 days ahead, and you may block unavailable slots on the app.
          </p>
          
          <h5 style={{ fontSize: "1.4rem", color: "#000000", fontFamily: "'Roboto', sans-serif", marginTop: "40px", fontWeight: "bold", }} >4. Professional Conduct & Service Guidelines</h5>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            Only provide beauty tips when confident and certain.
          </p>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            If a client experiences adverse effects (e.g., skin irritation), you must address the issue directly.
          </p>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            Use approved and safe products; Door to Door Beauty recommends brands like VLCC, Natures, Rica, Sleek, L’Oréal, or others introduced by us.
          </p>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            Service rates include transportation, and no extra charges or tips may be accepted from clients.
          </p>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            Always call the client before heading to the appointment. If the client cancels after you arrive due to emergencies, a reasonable conveyance fee will be reimbursed.
          </p>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            Keep your phone on and reachable at all times.
          </p>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            Assistants must be 18+ years and only assist; the professional must perform the majority of the service.
          </p>


          <h5 style={{ fontSize: "1.4rem", color: "#000000", fontFamily: "'Roboto', sans-serif", marginTop: "40px", fontWeight: "bold", }} >5. Feedback, Accountability & Penalties</h5>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            Negative feedback may require you to cover service costs if the appointment is provided for free. Door to Door Beauty covers 50% for the first two incidents; thereafter, the professional bears full responsibility.
          </p>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            Late arrivals may result in a 25% discount to the client, paid by the professional.
          </p>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            Professionals must not damage or steal client property.
          </p>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            Inform Door to Door Beauty and the client of any sensitive skin or conditions before performing the service.
          </p>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            Take full responsibility for any accidents or mishaps during service; the company is not liable.
          </p>

          <h5 style={{ fontSize: "1.4rem", color: "#000000", fontFamily: "'Roboto', sans-serif", marginTop: "40px", fontWeight: "bold", }} >6. Security & Tracking</h5>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            Ensure your personal safety during appointments. Door to Door Beauty is not responsible for your security.
          </p>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            Location tracking may be used via Google for operational and safety purposes.
          </p>



          <h5 style={{ fontSize: "1.4rem", color: "#000000", fontFamily: "'Roboto', sans-serif", marginTop: "40px", fontWeight: "bold", }} >7. Mandatory Feedback Form</h5>
          <p style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625",marginBottom: "10px",textAlign: "justify",}}>
            Carry and complete the Feedback Form at every appointment. Submit it immediately after completing the service.
          </p>

          {/* <ul style={{ fontSize: "1rem", color: "#000000", fontFamily: "'Roboto', sans-serif", lineHeight: "1.625", margin: "0 0 10px", paddingLeft: "40px", listStyleType: "decimal",}}>
            <li style={{ marginBottom: "10px" }}>Identifiers (e.g. name, mailing address, email address, phone number, credit/debit card number)</li>
            <li style={{ marginBottom: "10px" }}>Characteristics of protected classifications (e.g. gender, age)</li>
            <li style={{ marginBottom: "10px" }}>Commercial information (e.g. products or services purchased, purchase history)</li>
            <li style={{ marginBottom: "10px" }}>Internet or other electronic network activity (e.g. browse or search history)</li>
            <li style={{ marginBottom: "10px" }}>Geo location data (e.g. latitude or longitude)</li>
            <li style={{ marginBottom: "10px" }}>Audio, electronic, visual, or similar information (e.g. recording of Guest service calls)</li>
            <li style={{ marginBottom: "10px" }}>Inferences drawn from any of the above (e.g. preferences or characteristics)</li>
          </ul> */}

            {/* <Link
                className="inline-block w-auto text-pink-600 hover:text-pink-800 no-underline"
                href='/privacy-policy'
                target="_self"
                style={{color: "#DB2777;"}}
            >
                {" "}Privacy Policy.
            </Link> */}
            
        </div>
      </div>
   
   
      <FaqsStylistCard /> <br /><br />
    </div>
    
          
       


      


      {/* Rest of your component code goes here */}

      {/* Scroll-to-Top Button */}
      {showScrollButton && (
        <button
          className="fixed bottom-[100px] right-8 bg-pink-600 hover:bg-emerald-600 text-white p-3 rounded-full shadow-lg"
          onClick={scrollToTop}
        >
          ⬆️
        </button>
      )}
    </>
  );
}

export default TermsConditions;
